import * as APINormalizer from "../utils/APINormalizer";
import ApiConstants from "../constants/api";
import { api } from "./api";
import { isDevMode } from "../utils/Helpers";

const { MOCK_BARBER_NAMES } = ApiConstants;

/**
 * Fetch the compact barber data from the list endpoint
 * @TODO API not ready yet
 *
 * @return {Promise.<object, Error>} Resolves with barbershop data, rejects with errors
 */
export const getBarbers = () => {
  return new Promise((resolve, reject) => {
    api
      .get("/employees/")
      .then((response) => {
        const results = APINormalizer.barbersResponse(response.data);
        /**
         * The API response contains one or several test stores
         * meant only for development. We need to filter them out
         * from the public facing lists.
         */
        const publicResults = isDevMode()
          ? results
          : results.filter(
              ({ firstname }) => !MOCK_BARBER_NAMES.includes(firstname)
            );
        resolve(publicResults);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/**
 * Fetch the extended barbershop data from the shop endpoint
 *
 * @param {integer} id - Id of the barbershop
 * @return {Promise.<object, Error>} Resolves with barbershop data, rejects with errors
 */

export function getBarber(id) {
  return new Promise((resolve, reject) => {
    api
      .get(`/employees/${id}/`)
      .then((response) => {
        resolve(APINormalizer.barberResponse(response.data));
      })
      .catch((error) => {
        reject(error);
      });
  });
}
